var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component } from 'vue-property-decorator';
import VueDialog from "../../../interface/IVueDialog";
var ExportResult = (function (_super) {
    __extends(ExportResult, _super);
    function ExportResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.exportDetail = {};
        _this.listData = [];
        _this.checkedData = [];
        _this.remember = false;
        _this.Nopower = [];
        return _this;
    }
    ExportResult.prototype.created = function () {
        var _this = this;
        this.exportDetail = this.exportDetail;
        var data = Array.isArray(this.exportDetail.table_header_column) ? this.exportDetail.table_header_column : [];
        this.listData = data;
        this.listData.forEach(function (item) {
            if (item.is_hidden == 0) {
                _this.checkedData.push(item.name);
            }
        });
    };
    ExportResult.prototype.exportData = function () {
        var _this = this;
        this.listData.map(function (item) {
            item.is_hidden = _this.checkedData.indexOf(item.name) >= 0 ? 0 : 1;
        });
        this.exportDetail.table_header_column = this.listData;
        this.$emit("export:ok", JSON.stringify({
            exportDetail: this.exportDetail,
            remember: this.remember
        }));
        this.close();
    };
    ExportResult.prototype.close = function () {
        this.$closeDialog();
    };
    ExportResult.prototype.handleCheckedChange = function (value) {
    };
    ExportResult = __decorate([
        Component
    ], ExportResult);
    return ExportResult;
}(VueDialog));
export default ExportResult;
